<ng-container *ngIf="initiateResponseCard">
  <form [action]="initiateResponseCard.acsUrl" method="post" id="acs-form" class="cdk-visually-hidden" hidden target="output_frame">
    <input name="MD" [value]="initiateResponseCard.acsMD" id="MD" hidden>
    <input name="PaReq" [value]="initiateResponseCard.acsPayload" id="PaReq" hidden>
    <input name="TermUrl" [value]="initiateResponseCard.acsTermUrl" id="TermUrl" hidden>
  </form>
</ng-container>
<ng-container *ngIf="formSubmitted && !initiateResponseCard && !paymentCancelled">
  <div class="flex flex-col items-center justify-center h-full">
    <mat-spinner></mat-spinner>
    <p class="mt-4">Please complete your Payment With Google Pay</p>
  </div>
</ng-container>
<ng-container *ngIf="paymentCancelled && !initiateResponseCard">
  <div class="flex flex-col items-center justify-center h-full text-center">
    <img src="assets/icons/Icons/transaction-fail.png" alt="Error Icon">
    <h2 class="text-xl font-bold mb-2">Payment Method Cancelled</h2>
    <p class="text-gray-600 mb-4">Please try again or select another payment method to complete your transaction</p>
    <p class="text-gray-600 mb-6">Or Click the X at the top right to cancel the transaction.</p>
  </div>
</ng-container>
<ng-container *ngIf="!iframeLoaded && iframePostback">
  <div class="flex flex-col items-center justify-center h-full">
    <mat-spinner></mat-spinner>
    <p class="mt-4"><b>Confirming Transaction Status</b></p>
  </div>
</ng-container>

<iframe name="output_frame" class="external-iframe" [attr.data-loaded]="iframeLoaded" src="" *ngIf="formSubmitted && initiateResponseCard" #output_frame (load)="iframeOnLoad($event)"></iframe>
